import './SimpleLegend.scss';
import cn from 'classnames';
import { Dispatch, ReactElement, SetStateAction } from 'react';
import { ValueLabelRecord } from '@blisspointmedia/bpm-types/dist/App2Performance';
import { Neutral200 } from '@src/utils/colors';
import { InteractiveDiv } from '../../InteractiveEl';

const INACTIVE_COLOR = Neutral200;

interface LegendItem extends ValueLabelRecord {
  alwaysActive?: boolean;
}

interface SimpleLegendProps {
  legendItems: LegendItem[];
  activeItem: string | null;
  handleLegendClick: (area: string) => void;
  setHoveredLegend: Dispatch<SetStateAction<string | null>>;
  handleLegendEnter: (area: string) => void;
  hoveredLegend: string | null;
  colorMap: Record<string, string>;
  className?: string;
  showDash?: boolean;
  svg?: ReactElement;
}

export const SimpleLegend = ({
  legendItems,
  activeItem,
  hoveredLegend,
  colorMap,
  handleLegendClick,
  handleLegendEnter,
  setHoveredLegend,
  className,
  showDash = false,
  svg
}: SimpleLegendProps) => {
  const allItemsActive = activeItem === null;
  return (
    <div className='simple-legend-container'>
      <div className='simple-legend'>
        {legendItems.map(item => {
          const isActiveItem = allItemsActive || item.alwaysActive || activeItem === item.value;
          const isHoveredLegend = hoveredLegend === null ? true : hoveredLegend === item.value;
          const activeColor = isActiveItem ? colorMap?.[item.value] : INACTIVE_COLOR;
          const hoverColor = isHoveredLegend ? colorMap?.[item.value] : INACTIVE_COLOR;

          return (
            <InteractiveDiv
              className='simple-legend-item'
              key={item.value}
              onClick={() => handleLegendClick(item.value)}
              onMouseEnter={() => handleLegendEnter(item.value)}
              onMouseLeave={() => setHoveredLegend(null)}
            >
              <div className='legend-value'>
                <div className={cn({ 'inactive-legend': !isActiveItem })}>
                  <div className='legend-icon-wrapper'>
                    {activeItem === item.value && svg ? (
                      <svg className='legend-icon' viewBox='0 0 16 12' preserveAspectRatio='none'>
                        {svg}
                      </svg>
                    ) : (
                      <div
                        className={cn('legend-icon', 'simple-icon', className, {
                          active: isActiveItem,
                          dash: showDash
                        })}
                        style={{
                          backgroundColor: activeItem ? activeColor : hoverColor
                        }}
                      />
                    )}
                    <div className='legend-label'>{item.label}</div>
                  </div>
                </div>
              </div>
            </InteractiveDiv>
          );
        })}
      </div>
    </div>
  );
};
